import Api from '@/api/Api';

class ThinkificEnrollmentsApi extends Api {
  constructor() {
    super('thinkific/enrollments', 'Thinkific Enrollments');
  }
}
const thinkificEnrollmentsApi = new ThinkificEnrollmentsApi();
export default thinkificEnrollmentsApi;
